import React from 'react'
import styled from 'styled-components'
import { components } from 'react-select'
import colors from '../../../configuration/colors'
import FlexContainer from '../../styled/FlexContainer'
import Phase from '../../mini/Phase'

import PastJourneySvg from '../../../static/images/icons/icon_past-journey.svg'
import FutureJourneySvg from '../../../static/images/icons/icon_future_journey.svg'
import { MasterCourseName } from '../_Styled'
import { H5 } from '../../styled/typography/typography'

const Container = styled(H5)`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  height: 42px;
  minWidth: fit-content;
  padding: 0 20px;
  background: ${props => props.isFocused
    ? props.theme?.selectHighlight
    : props.isSingeValue
      ? 'transparent'
      : props.theme?.selectBackground};
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
`

const InactiveJourneyIcon = styled.img.attrs(props => ({
  src: props.future ? FutureJourneySvg : PastJourneySvg,
  alt: props.future ? 'Future' : 'Past'
}))`
  height: 12px;
  width: 12px;
  margin-right: 6px;
`
const MasterCourseSelectOSVHOC = isSingeValue => innerProps => {
  const theme = innerProps.selectProps.userTheme

  return (
    innerProps.data.isAcademicYear ? (
      <components.Option {...innerProps}>
        <Container
          isFocused={innerProps.isFocused}
          isSingeValue={isSingeValue}
        >
          {innerProps.data.label}
        </Container>
      </components.Option>
    ) : innerProps.data.value > -1 ? (
      <components.Option {...innerProps}>
        <Container
          isFocused={innerProps.isFocused}
          isSingeValue={isSingeValue}
          className="journey-option"
        >
          <Phase size={16} phase={innerProps.data.gradeLevel} />

          {!innerProps.data.active && (
            <InactiveJourneyIcon future={innerProps.data.future} />
          )}

          <MasterCourseName color={innerProps.data.color}>
            {innerProps.data.name}
          </MasterCourseName>
        </Container>
      </components.Option>
    ) : (
      <components.Option {...innerProps}>
        <Container
          isFocused={innerProps.isFocused}
          isSingeValue={isSingeValue}
          isAllActive
        >
          {innerProps.data.label}
        </Container>
      </components.Option>
    )
  )
}

export const MasterCourseSelectOption = MasterCourseSelectOSVHOC(false)
export const MasterCourseSelectSingleValue = MasterCourseSelectOSVHOC(true)
